import {
  Body2,
  Box,
  Heading5,
  Join,
  ListItem,
  Space,
  UnorderedList,
} from '@gousto-internal/citrus-react';
import { IngredientProps } from './types';

export function Ingredients({ ingredients }: IngredientProps) {
  return (
    <Box data-testid="ingredients">
      <Heading5>Ingredients</Heading5>
      <Space size={2} />
      <Body2>
        Ingredients shown are for 2 people. For allergens, see the &apos;Ingredients contain&apos;
        section.
      </Body2>
      <Space size={4} />
      <UnorderedList style={{ margin: 0, padding: 0 }}>
        <Join with={<Space size={2} />}>
          {ingredients.map((ingredient) => (
            <ListItem key={ingredient.name}>
              <Body2>{ingredient.name}</Body2>
            </ListItem>
          ))}
        </Join>
      </UnorderedList>
    </Box>
  );
}
